import { PromptType } from "@/components/tasks/types";
import SingleLineTextbox from "./SingleLineTextbox";
import MultiLineTextbox from "./MultiLineTextbox";
import NumericInput from "./NumericInput";
import MultipleChoice from "./MultipleChoice";
import Dropdown from "./Dropdown";
import Checkbox from "./Checkbox";
import ConvoBreak from "./ConvoBreak";

export const PROMPT_COMPONENTS = {
  "single-line-textbox": SingleLineTextbox,
  "multi-line-textbox": MultiLineTextbox,
  numeric: NumericInput,
  "multiple-choice": MultipleChoice,
  dropdown: Dropdown,
  checkbox: Checkbox,
  "convo-break": ConvoBreak,
} as const;

export type PromptComponent = (typeof PROMPT_COMPONENTS)[PromptType];

export {
  SingleLineTextbox,
  MultiLineTextbox,
  NumericInput,
  MultipleChoice,
  Dropdown,
  Checkbox,
  ConvoBreak,
};
